import React from 'react';

import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import ConnectionFinishedMobile from '../ConnectionFinished/ConnectionFinishedMobile';
import ConnectionPageContent from './ConnectionPageContent';

const ConnectionPageMobile = ({currentStep, steps, isConnectionFinished, onOpenQsg, deviceType}) => {
    return isConnectionFinished ? (
        <ConnectionFinishedMobile onOpenQsg={onOpenQsg} deviceType={deviceType} />
    ) : (
        <div className='flex flex-col pt-0-hw-offset'>
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.CONNECTION} />
            <ConnectionPageContent
                currentStep={currentStep}
                steps={steps}
                className='pt-safe-offset-sticky-header flex-1 px-6 pb-6'
                onOpenQsg={onOpenQsg}
                deviceType={deviceType}
            />
            <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.CONNECTION} />
        </div>
    );
};

export default ConnectionPageMobile;
